import { ILpElementLink, ILpElementSimpleList } from '../declarations/contentful';

/**
 * Type guard to check if an item is a simple link (ILpElementLink) or a list (ILpElementSimpleList)
 */
export function isSimpleLink(item: ILpElementLink | ILpElementSimpleList): item is ILpElementLink {
  return item?.fields != null && 'text' in item.fields && 'url' in item.fields;
}

/**
 * Type guard to check if an item is a simple list (ILpElementSimpleList) with nested links
 */
export function isSimpleList(
  item: ILpElementLink | ILpElementSimpleList,
): item is ILpElementSimpleList {
  return item?.fields != null && 'title' in item.fields && 'links' in item.fields;
}
